import { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import { useMeasure } from 'react-use';
import { useTranslation } from 'react-i18next';

import { useTextEditorStore } from './TextEditorStore';
import { FitText } from './FitText';

export const TextEditor: FC = () => {
  const { text, resetStore } = useTextEditorStore();
  const [ref, { width, height }] = useMeasure();
  const { t } = useTranslation();
  const size = Math.min(width, height);
  const minfontSize = 0.05 * size;
  const maxfontSize = 0.17 * size;
  const textMargin = size * 0.1;

  useEffect(() => {
    // Reset the store when the component mounts
    resetStore();
  }, []);

  let logoText = text;

  if (!text) {
    logoText = t('yourName');
  }

  return (
    <>
      <Box
        ref={ref}
        sx={{
          height: '100%',
          width: '100%',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: size,
            height: size,
            top: (height - size) / 2,
            left: (width - size) / 2,
            // backgroundColor: '#E08888FF',
            backgroundImage: "url('/logo_editor_bg.png')",
            backgroundColor: '#0032a0',
            backgroundSize: 'contain',
            boxShadow: '15px 15px 8px 0px #8a8ea6',
            borderRadius: 400,
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: size,
              height: size,
              top: 0,
              left: 0,
              borderRadius: 400,
              boxShadow:
                '-2px -2px 3px rgba(0,0,0,.55) inset, 1px 1px 2px white inset',
              background:
                'linear-gradient(128deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.03) 49%, rgba(255, 255, 255, 0) 51%, rgba(255, 255, 255, 0) 100%)',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: textMargin,
                bottom: size * 0.129,
                left: textMargin,
                display: 'flex',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                // backgroundColor: '#00FF00AE',
              }}
            >
              <Box
                sx={{
                  fontWeight: 700,
                  // color: '#BA5959FF',
                  color: '#FFFFFF',
                  textTransform: 'uppercase',
                  userSelect: 'none',
                }}
                component={FitText}
                key={`${text}-${size}`}
                minSize={minfontSize}
                maxSize={maxfontSize}
              >
                {logoText}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
